// extracted by mini-css-extract-plugin
export var services = "services-module--services--7IJHC";
export var center = "services-module--center--whAmG";
export var service = "services-module--service--iBdyO";